<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><router-link to="/kr/mypage/health/bloodPressure">혈압</router-link></li>
            <li class="tab-menu__item"><router-link to="/kr/mypage/health/bloodSugar">혈당</router-link></li>
            <li class="tab-menu__item"><router-link to="/kr/mypage/health/bodyMass">체질량</router-link></li>
        </ul>
    </div>
    <div class="info">
        <div class="table-search">
            <VueDatePicker v-model="selectedDateRange" locale="ko"
                      :enable-time-picker="false" :format="customFormat"
                      :week-start="0" :day-class="getDayClass"
                      :select-text="'선택'" :cancel-text="'취소'" placeholder="날짜를 선택하세요."/>
            

            <TimePicker v-model="time" format="HH:mm" minute-step="1" is24 />
        </div>
        <ul class="blood-scheduler">
            <li class="blood-scheduler__item">
                <div class="blood-scheduler__con">
                    <div class="blood-scheduler__top">
                        <div class="blood-scheduler--img">
                            <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/mypage-main__item6-icon01.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/mypage-main__item6-icon01-brain.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/mypage-main__item6-icon01-mom.svg" class="" alt="">
                        </div>
                        <h3 class="title02">수축기혈관</h3>
                    </div>
                    <div class="blood-scheduler__input">
                        <input type="text" v-model="systolic" @input="validateInput('systolic', $event)">
                        <p class="title03">mmHg</p>
                    </div>
                </div>
                <sub>이완기혈압보다 큰 숫자를 입력해주세요.</sub>
            </li>
            <li class="blood-scheduler__item">
                <div class="blood-scheduler__con">
                    <div class="blood-scheduler__top">
                        <div class="blood-scheduler--img">
                            <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/mypage-main__item6-icon04.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/mypage-main__item6-icon04-brain.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/mypage-main__item6-icon04-mom.svg" class="" alt="">
                        </div>
                        <h3 class="title02">이완기혈압</h3>
                    </div>
                    <div class="blood-scheduler__input">
                        <input type="text" v-model="diastolic" @input="validateInput('diastolic', $event)">
                        <p class="title03">mmHg</p>
                    </div>
                </div>
                <sub>수축기혈압보다 작은 숫자를 입력해주세요.</sub>
            </li>
        </ul>
        <div class="botton-wrap">
            <a href="javascript:;" class="main-button c-main" @click="calculateResult">측정하기</a>
        </div>
    </div>
    <div class="info" v-if="!result">
        <div class="text-box type3">
            <h3 class="title03">혈압 측정 방법</h3>
            <p class="bullet03">혈압 측정 30분 전에는 알코올, 커피(카페인) 섭취와 운동, 목욕을 피하고 금연을 합니다.</p>
            <p class="bullet03">5분 이상 앉은 자세로 심리적 안정을 취하도록 합니다.</p>
            <p class="bullet03">혈압을 잴 때, 팔의 위치는 심장의 위치와 비슷해야 합니다.</p>
            <p class="bullet03">혈압은 특별한 경우가 아니라면, 앉아서 팔에서 측정합니다.</p>
            <p class="bullet03">측정 시 말을 하거나 움직이지 않습니다.</p>
            <p class="bullet03">혈압이 정상보다 높을 경우, 2번 이상 다시 측정합니다.</p>
        </div>
    </div>

    <!-- 측정시 -->
    <div class="info" v-if="result">
        <div class="text-box type3">
            <div class="emphasis">
                <div class="emphasis--icon">
                    <span style="display: contents;" v-if="result == '정상'">
                        <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-good.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-good-brain.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-good-mom.svg" class="" alt="">
                    </span>
                    <span style="display: contents;" v-else>
                        <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-warning.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-warning-brain.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-warning-mom.svg" class="" alt="">
                    </span>
                </div>
                <h3 class="title01">현재 혈압 상태는 <br class="show-mo"><span :class="result == '정상' ? 'c-blue' : 'c-red'">‘{{result}}’</span> 입니다.</h3>
            </div>
        </div>
    </div>
    <div class="info" v-if="result">
        <div class="table-wrap">
            <div class="table">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:33.33%;">
                            <col style="width:33.33%;">
                            <col style="width:33.33%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>혈압분류</th>
                                <th>수축기혈압</th>
                                <th>이완기혈압</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>저혈압</td>
                                <td>90 이하</td>
                                <td>60 이하</td>
                            </tr>
                            <tr>
                                <td>정상</td>
                                <td>91~119</td>
                                <td>61~79</td>
                            </tr>
                            <tr>
                                <td>전고혈압</td>
                                <td>120~139</td>
                                <td>80~89</td>
                            </tr>
                            <tr>
                                <td>1기고혈압</td>
                                <td>140~159</td>
                                <td>90~99</td>
                            </tr>
                            <tr>
                                <td>2기고혈압</td>
                                <td>160 이상</td>
                                <td>100 이상</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="botton-wrap" v-if="result">
            <a href="javascript:;" class="main-button c-main" @click="saveSubmit">결과저장</a>
        </div>
    </div>
    <kr_popup_health ref="MypagePopupVue"/>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import TimePicker from 'vue3-timepicker';
import 'vue3-timepicker/dist/VueTimepicker.css';
import { useRoute } from 'vue-router'

export default {
    components: {
        VueDatePicker,
        TimePicker,
    },
    data() {
        return {
            time: {HH: "", mm: ""},  // 시간 선택값을 저장
            selectedDateRange: new Date(), // 날짜 선택값
            customFormat: 'yyyy-MM-dd',  // 날짜 포맷
            formatDate: 'yyyy-MM-dd',  // 날짜 포맷

            systolic: '',
            diastolic: '',
            result: '',
        };
    },
    methods: {
        validateInput(type, event) {
            const input = event.target.value.replace(/[^\d]/g, '').slice(0, 3)
            this[type] = input
        },
        calculateResult() {
            const systolic = parseInt(this.systolic)
            const diastolic = parseInt(this.diastolic)

            if (!this.systolic || !this.diastolic) {
                alert("데이터를 입력해 주세요")
                return
            }

            if (systolic <= diastolic) {
                alert("수치를 다시 입력해주세요.")
                return
            }

            if (systolic <= 90 ) {
                this.result = "저혈압"
            } else if (
                systolic >= 91 &&
                systolic <= 119
            ) {
                this.result = "정상"
            } else if (
                systolic >= 120 &&
                systolic <= 139
            ) {
                this.result = "전고혈압"
            } else if (
                systolic >= 140 &&
                systolic <= 159
            ) {
                this.result = "1기고혈압"
            } else if (systolic >= 160 ) {
                this.result = "2기고혈압"
            } else {
                alert("혈압 범위를 벗어났습니다. 다시 입력해주시길 바랍니다.")
                return
            }

            if(this.result){
                this.$nextTick(() => {
                    const el = document.querySelector('.text-box.type3')
                    const top = el.getBoundingClientRect().top;
                    const curY = window.pageYOffset
                    const header = document.querySelector('.header-bottom').clientHeight
                    const sum = top + curY - header
                    window.scrollTo({top: sum})
                });
            }
        },
        getDayClass(date) {
            const day = date.getDay()
            if (day === 0) {
                return "sunday-class"
            } else if (day === 6) {
                return "saturday-class"
            }
            return ""
        },
        saveSubmit() {
            this.$refs.MypagePopupVue.popupBtn()
        },
        submit() {
            let reqData = {
                hmCd: 'BP'
            }

            var year = this.selectedDateRange.getFullYear()
            var month = ('0' + (this.selectedDateRange.getMonth() + 1)).slice(-2)
            var day = ('0' + this.selectedDateRange.getDate()).slice(-2)
            var hours = this.time.HH ? this.time.HH : ('0' + this.time.getHours()).slice(-2)
            var min = this.time.mm ? this.time.mm : ('0' + this.time.getMinutes()).slice(-2)

            reqData.logDt = year + '' + month + '' + day + '' + hours + '' + min + '00'
            reqData.record1 = this.systolic
            reqData.record2 = this.diastolic
            reqData.record3 = ''
            reqData.result = this.result
            this.axios({
                method: "post",
                url: this.api.mypage.healthReg,
                params: reqData
            }).then(response => {
                alert('저장되었습니다.')

                this.systolic = ''
                this.diastolic = ''
                this.result = ''

                this.$router.push('/kr/mypage/health/bloodMain')
            })
        },
    },
    mounted() {
        const now = new Date()

        this.time.HH = now.getHours().toString().padStart(2, '0');
        this.time.mm = now.getMinutes().toString().padStart(2, '0');

        this.selectedDateRange = this.$store.state.reserveStore.bloodDate || now

        // 테이블의 .table에 클릭 이벤트를 추가
        const tables = document.querySelectorAll('.table');

        tables.forEach((table) => {
            // .table 요소의 가상 요소 부분을 클릭한 것처럼 처리할 수 있게,
            // 테이블의 `::before`가 클릭될 수 있는 영역을 감싸는 영역을 클릭 이벤트로 처리
            table.addEventListener('click', () => {
                // 테이블에 'active' 클래스를 토글
                table.classList.add('active');
            });
        });
    },
    beforeUnmount() {
        if(!(useRoute().path == '/kr/mypage/health/bloodPressure'
            || useRoute().path == '/kr/mypage/health/bloodSugar'
            || useRoute().path == '/kr/mypage/health/bodyMass')) this.$store.commit('setBloodDate', '')
    },
}
</script>

<style scoped></style>